// extracted by mini-css-extract-plugin
module.exports = {"financialToolsDesktop":"FinancialToolsDesktop--financialToolsDesktop--3aEsL","links":"FinancialToolsDesktop--links--1nCkg","base":"FinancialToolsDesktop--base--3bk1v"};